<template>
<!--  <div class="site-form-layer construct-form-layer max-1032">-->
<!--    <div class="site-form-title construct-form-title">1. Тип заявления</div>-->
<!--    &lt;!&ndash;    <div class="site-form-row construct-form-row">&ndash;&gt;-->
<!--    &lt;!&ndash;      <div class="site-form-col construct-form-col">&ndash;&gt;-->
<!--    &lt;!&ndash;        <dropdown v-if="typeDocument" :values="typeDocument" v-model="form.STATEMENT" name="STATEMENT" label="Заявление"/>&ndash;&gt;-->
<!--    &lt;!&ndash;      </div>&ndash;&gt;-->
<!--    &lt;!&ndash;    </div>&ndash;&gt;-->

<!--    <div class="site-form-row construct-form-row">-->
<!--      <div class="site-form-col construct-form-col">-->
<!--        <dropdown v-if="typeApplicant" :values="typeApplicant" v-model="form.APPLICANT" name="APPLICANT" label="Тип заявителя"/>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

  <div class="site-form-layer construct-form-layer max-1032">
    <div class="site-form-title construct-form-title">1. Информация о заявителе</div>
    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col">
        <form-input label="Фамилия" v-model="form.APPLICANT_FAMILY" name="APPLICANT_FAMILY"/>
      </div>
    </div>

    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col">
        <form-input label="Имя" v-model="form.APPLICANT_NAME" name="APPLICANT_NAME"/>
      </div>
    </div>

    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col">
        <form-input label="Отчество" v-model="form.APPLICANT_SECOND_NAME" name="APPLICANT_SECOND_NAME"/>
      </div>
    </div>

    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col x6">
        <datepicker label="Дата рождения" v-model="form.APPLICANT_DOB" name="APPLICANT_DOB"/>
      </div>
    </div>

    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col">
        <form-input label="Место рождения" v-model="form.APPLICANT_PLACE_BIRTH" name="APPLICANT_PLACE_BIRTH"/>
      </div>
    </div>

    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col">
        <form-input label="Адрес регистрации" v-model="form.APPLICANT_REG_ADDRESS" name="APPLICANT_REG_ADDRESS"/>
      </div>
    </div>

    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col">
        <form-input label="Адрес проживания" v-model="form.APPLICANT_POST_ADDRESS" name="APPLICANT_POST_ADDRESS"/>
      </div>
    </div>

  </div>

  <div class="site-form-layer construct-form-layer max-1032">
    <div class="site-form-title construct-form-title m-0">2. Контактные данные</div>
    <div class="construct-form-group-container">
      <div class="construct-form-group">
        <div class="construct-form-explant">Данные для связи</div>

        <div class="site-form-row construct-form-row">
          <div class="site-form-col construct-form-col">
            <phone label="Моб. Телефон" v-model="form.PHONE_1" name="PHONE_1"/>
          </div>
        </div>

        <div class="site-form-row construct-form-row">
          <div class="site-form-col construct-form-col">
            <form-input label="E-Mail" v-model="form.EMAIL_1" name="EMAIL_1"/>
          </div>
        </div>

      </div>
      <div class="construct-form-group">
        <div class="construct-form-explant">Дополнительные данные для связи</div>

        <div class="site-form-row construct-form-row">
          <div class="site-form-col construct-form-col">
            <phone label="Моб. Телефон" v-model="form.PHONE_2" name="PHONE_2"/>
          </div>
        </div>

        <div class="site-form-row construct-form-row">
          <div class="site-form-col construct-form-col">
            <form-input label="E-Mail" v-model="form.EMAIL_2" name="EMAIL_2"/>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="site-form-layer construct-form-layer max-1032">
    <div class="site-form-title construct-form-title">3. Документ, удостоверяющий личность</div>
    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col x6">
        <dropdown v-if="variantDocument" :values="variantDocument" label="Вид документа" v-model="form.DOCUMENT_TYPE" name="DOCUMENT_TYPE"/>
      </div>
    </div>

    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col x4">
        <form-input label="Серия" v-model="form.DOCUMENT_SERIES" name="DOCUMENT_SERIES"/>
      </div>

      <div class="site-form-col construct-form-col x4">
        <form-input label="Номер" v-model="form.DOCUMENT_NUMBER" name="DOCUMENT_NUMBER"/>
      </div>

      <div class="site-form-col construct-form-col x4">
        <datepicker label="Дата выдачи" v-model="form.DOCUMENT_DATE" name="DOCUMENT_DATE"/>
      </div>

      <div class="site-form-col construct-form-col x4">
        <form-input label="Код подразделения" v-model="form.DOCUMENT_CODE" name="DOCUMENT_CODE"/>
      </div>
    </div>

    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col">
        <form-input label="Кем выдан" v-model="form.DOCUMENT_SENDER" name="DOCUMENT_SENDER"/>
      </div>
    </div>

    <div class="site-form-row construct-form-row">
    </div>
  </div>

  <!--  <div class="site-form-layer construct-form-layer max-1032">-->
  <!--    <div class="site-form-title construct-form-title">5. Сведения о государственной регистрации</div>-->

  <!--    <div class="site-form-row construct-form-row">-->
  <!--      <div class="site-form-col construct-form-col">-->
  <!--        <form-input label="ИНН" v-model="form.INN" name="INN"/>-->
  <!--      </div>-->
  <!--    </div>-->

  <!--    <div class="site-form-row construct-form-row">-->
  <!--      <div class="site-form-col construct-form-col">-->
  <!--        <checkbox label="Договор подписывает доверенное лицо" v-model="form.CONFIDANT" name="CONFIDANT"/>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->

  <div class="site-form-layer construct-form-layer max-1032">
    <div class="site-form-title construct-form-title">4. Прошу заключить договор в отношении объекта(ов)</div>

    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col">
        <form-input label="Наименование объекта" v-model="form.OBJECT_NAME" name="OBJECT_NAME"/>
      </div>
    </div>

    <div class="site-form-row construct-form-row">
      <!--      <div class="site-form-col construct-form-col x6">-->
      <!--        <form-input label="Район" v-model="form.OBJECT_REGION" name="OBJECT_REGION"/>-->
      <!--      </div>-->

      <div class="site-form-col construct-form-col x6">
        <form-input label="Населенный пункт" v-model="form.OBJECT_CITY" name="OBJECT_CITY"/>
      </div>

      <div class="site-form-col construct-form-col x6">
        <form-input label="Улица" v-model="form.OBJECT_STREET" name="OBJECT_STREET"/>
      </div>
    </div>

    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col x4">
        <form-input label="Корпус" v-model="form.OBJECT_HOUSE" name="OBJECT_HOUSE"/>
      </div>

      <div class="site-form-col construct-form-col x4">
        <form-input label="Дом" v-model="form.OBJECT_HOME" name="OBJECT_HOME"/>
      </div>

      <div class="site-form-col construct-form-col x4">
        <form-input label="Квартира, секция" v-model="form.OBJECT_APARTMENT" name="OBJECT_APARTMENT"/>
      </div>

      <div class="site-form-col construct-form-col x4">
        <form-input label="Комната" v-model="form.OBJECT_ROOM" name="OBJECT_ROOM"/>
      </div>
    </div>
  </div>

  <div class="site-form-layer construct-form-layer max-1032">
    <div class="site-form-title construct-form-title">4.1 Характеристика жилого помещения, наличие иных надворных построек:</div>

    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col x6">
        <form-input label="Площадь" v-model="form.OBJECT_SQUARE" name="OBJECT_SQUARE"/>
      </div>
      <div class="site-form-col construct-form-col x6">
        <form-input label="Кол-во комнат" v-model="form.COUNT_ROOM" name="COUNT_ROOM"/>
      </div>
    </div>

    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col x3">
        <form-input label="Кол-во зарегистрированных" v-model="form.OBJECT_ROOMS" name="OBJECT_ROOMS"/>
      </div>
      <div class="site-form-col construct-form-col x3">
        <form-input label="Кол-во фактически проживающих" v-model="form.OBJECT_COUNT_FACT_ALIVE" name="OBJECT_COUNT_FACT_ALIVE"/>
      </div>
      <div class="site-form-col construct-form-col x3">
        <form-input label="Количество собственников" v-model="form.OBJECT_COUNT_OWNER" name="OBJECT_COUNT_OWNER"/>
      </div>
    </div>

  </div>


  <div class="site-form-layer construct-form-layer max-1032">
    <div class="site-form-title construct-form-title">5. Информация о договоре</div>
    <div class="site-form-row construct-form-row">
      <div class="site-form-col construct-form-col">
        <dropdown v-if="receiveAgreement" :values="receiveAgreement" name="RECEIVE_AGREEMENT" v-model="form.RECEIVE_AGREEMENT" label="Способ получения договора"/>
      </div>
    </div>
  </div>

  <div class="site-form-layer construct-form-layer max-1032" id="docs">
    <div class="site-form-title construct-form-title">Перечень документов необходимых для заключения договора энергоснабжения и купли-продажи</div>
    <div class="construct-form-upload-container">
      <div class="construct-form-upload">
        <div class="construct-form-upload-item">
          <div class="construct-form-upload-title">1. Свидетельство о гос. регистрации права (или Выписка из ЕГРН)</div>
          <file
              v-model="form.FILE_CERT_REG"
              name="FILE_CERT_REG"
              :accept="getExtension('FILE_CERT_REG')"
          />
        </div>
      </div>
      <div class="construct-form-upload">
        <div class="construct-form-upload-item">
          <div class="construct-form-upload-title">2. Паспорт</div>
          <file
              v-model="form.FILE_PASSPORT"
              name="FILE_PASSPORT"
              :accept="getExtension('FILE_PASSPORT')"
          />
        </div>
      </div>
      <div class="construct-form-upload">
        <div class="construct-form-upload-item">
          <div class="construct-form-upload-title">3. Договор купли-продажи (дарения, завещания и т.п.)</div>
          <div class="construct-form-upload-point">При наличии</div>
          <file
              v-model="form.FILE_AGREEMENT"
              name="FILE_AGREEMENT"
              :accept="getExtension('FILE_AGREEMENT')"
          />
        </div>
        <div class="construct-form-upload-item">
          <div class="construct-form-upload-title">4. СНИЛС</div>
          <div class="construct-form-upload-point">При наличии</div>
          <file
              v-model="form.FILE_SNILS"
              name="FILE_SNILS"
              :accept="getExtension('FILE_SNILS')"
          />
        </div>
        <div class="construct-form-upload-item">
          <div class="construct-form-upload-title">5. ИНН</div>
          <div class="construct-form-upload-point">При наличии</div>
          <file
              v-model="form.FILE_INN"
              name="FILE_INN"
              :accept="getExtension('FILE_INN')"
          />
        </div>
        <div class="construct-form-upload-item">
          <div class="construct-form-upload-title">6. Выписка из домовой книги</div>
          <div class="construct-form-upload-point">При наличии</div>
          <file
              v-model="form.FILE_EXTRACT_HOUSE"
              name="FILE_EXTRACT_HOUSE"
              :accept="getExtension('FILE_EXTRACT_HOUSE')"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import File from "../../form/file.vue";
import Checkbox from "../../form/checkbox.vue";
import FormInput from "../../form/input.vue";
import Dropdown from "../../form/dropdown.vue";
import Datepicker from "../../form/datepicker.vue";
import Phone from "../../form/phone.vue";

export default {
  name: "phys-template",
  components: {Phone, Datepicker, File, Checkbox, FormInput, Dropdown},
  data() {
    return {
      countBanks: 1,
      countObjects: 1,
    };
  },
  props: {
    form: {
      type: Object,
      default: null
    },
    formKey: {
      type: String,
      default: null
    },
    typeApplicant: {
      type: Object,
      default: null
    },
    typeDocument: {
      type: Object,
      default: null
    },
    variantDocument: {
      type: Object,
      default: null
    },
    typeDevice: {
      type: Object,
      default: null
    },
    receiveAgreement: {
      type: Object,
      default: null
    },
    propertyExtensions: {
      type: Object,
      default: null
    },
  },
  methods: {
    getExtension(propertyCode) {
      return this.propertyExtensions[propertyCode] ?? '*/*';
    },
    submitFormThis(event) {
      this.$emit('submitForm', event);
    }
  }
}
</script>

<style scoped>

</style>